module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isMine(_vm.tournament)) ? _c('div', [_c('md-list', [_c('md-toolbar', [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.showAddCompetitorsDialog = true
      }
    }
  }, [_c('md-icon', [_vm._v("group_add")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Add competitors")])], 1)], 1), _vm._v(" "), _c('AddCompetitorsDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "show": _vm.showAddCompetitorsDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showAddCompetitorsDialog = false
      }
    }
  }), _vm._v(" "), _c('md-list-item', {
    staticClass: "rankings",
    attrs: {
      "md-expand": ""
    }
  }, [_c('md-icon', [_vm._v("sort")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Adjust Rankings")]), _vm._v(" "), _c('md-list', {
    staticClass: "rankings",
    attrs: {
      "slot": "md-expand"
    },
    slot: "md-expand"
  }, [_c('md-list-item', [_c('md-toolbar', [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.resetRankings
    }
  }, [_c('md-icon', [_vm._v("cancel")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Reset rankings")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "disabled": !_vm.rankingsChanged
    },
    on: {
      "click": _vm.commitRankings
    }
  }, [_c('md-icon', [_vm._v("save")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Commit new rankings")])], 1)], 1)], 1), _vm._v(" "), _c('md-list-item', [_c('div', [_c('p', {
    staticClass: "ranking-instructions"
  }, [_vm._v("Drag and drop the competitors in the desired ranking, stronger competitors at the top. Be sure to commit the rankings before generating the draw.")])])]), _vm._v(" "), _c('md-list-item', [_c('draggable', {
    staticClass: "list-group",
    attrs: {
      "element": "ul",
      "options": _vm.dragOptions
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.rankedCompetitors),
      callback: function($$v) {
        _vm.rankedCompetitors = $$v
      },
      expression: "rankedCompetitors"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": !_vm.drag ? 'flip-list' : null
    }
  }, _vm._l((_vm.rankedCompetitors), function(element) {
    return _c('li', {
      key: element.id,
      staticClass: "list-group-item"
    }, [_c('md-icon', [_vm._v("person")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(element.name))]), _vm._v(" "), _c('span', {
      staticClass: "rank"
    }, [_vm._v(_vm._s(element.rank))])], 1)
  }))], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tournament && _vm.tournament.competitors.length > 0) ? _c('div', [_c('div', {
    staticClass: "flex-container"
  }, [_c('CompetitorList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Not ready",
      "competitors": _vm.pendingCompetitors,
      "tournament": _vm.tournament
    }
  }), _vm._v(" "), _c('CompetitorList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Ready",
      "competitors": _vm.readyCompetitors,
      "tournament": _vm.tournament
    }
  }), _vm._v(" "), _c('CompetitorList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Eliminated",
      "competitors": _vm.eliminatedCompetitors,
      "tournament": _vm.tournament
    }
  }), _vm._v(" "), _c('CompetitorList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Inactive",
      "competitors": _vm.inactiveCompetitors,
      "tournament": _vm.tournament
    }
  })], 1)]) : _c('div', [_c('md-empty-state', {
    attrs: {
      "md-icon": "people_outline",
      "md-label": "No Competitors yet"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f9cd2b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tournamentComponents/tournamentCompetitors.vue
// module id = 436
// module chunks = 1